import React from "react";
import styled from "styled-components";
import { useHistory } from "react-router";
import { HyperLinkDiv } from "./HyperLinkDiv";
import { HyperLinkSpan } from "./HyperLinkSpan";
import { handleNavigation } from "../../helpers/handleNavigation";

export const Link = styled.div`
  color: #98a6ad;
  display: block;
  padding: 0.5rem 1rem;
  cursor: pointer;

  :hover {
    background-color: #313a46;
  }
`;

const handleClick = (to) => (e) => {
  e.stopPropagation();
  window.open(to);
};

const NavLink = ({ to, name }) => {
  const { push } = useHistory();

  const handleLinkClick = (event) => {
    handleNavigation(event, to, push);
  };

  return <Link onClick={handleLinkClick}>{name}</Link>;
};

export const ExternalNavLink = ({ to, name }) => <Link onClick={handleClick(to)}>{name}</Link>;

export const ExternalLink = ({ to, name }) => <HyperLinkDiv onClick={handleClick(to)}>{name}</HyperLinkDiv>;

export const ExternalHyperLink = ({ to, name }) => <HyperLinkSpan onClick={handleClick(to)}>{name}</HyperLinkSpan>;

export default NavLink;
